<template>
    <div>
        <div class="card dashcard mb-0">
            <div class="card-body">
                <div class="form-row">
                    <div class="col col-md-6">
                        <az-periodo v-model="filtros" :sync="true" @sync="load(false)" />
                    </div>
                    <div class="col col-12 col-md-6">
                        <az-input
                            icon="far fa-credit-card"
                            type="select"
                            optionsMode="aql"
                            optionsData="id_operadora"
                            optionsDisplay="st_operadora"
                            service="operadoras.index"
                            placeholder="Todas as Operadoras..."
                            v-model="filtros.id_operadora">
                        </az-input>
                    </div>
                </div>
                <div class="form-row mt-2">
                    <div class="col col-12 col-md-2">
                        <az-input
                            icon="far fa-calendar fa-fw"
                            placeholder="Data de Abertura"
                            type="select"
                            optionsMode="json"
                            :optionsList="[
                                { id: 'I', search: 'Data Inicial' },
                                { id: 'F', search: 'Data Final' },
                            ]"
                            optionsData="id"
                            v-model="filtros.tipo_data">
                        </az-input>
                    </div>
                    <div class="col col-12 col-md-4">
                        <az-input
                            icon="fa fa-search fa-fw"
                            type="text"
                            placeholder="Pesquisar por..."
                            v-model="filtros.pesquisar"
                            @onEnter="load(false)"
                            :shortkey="['ctrl', 'p']">
                        </az-input>
                    </div>
                    <div class="col col-12 col-md-3">
                        <az-input
                            type="select"
                            :optionsList="lista_unidades"
                            optionsData="id_unidade_operacao"
                            icon="fa fa-building fa-fw"
                            placeholder="Todas as Unidades..."
                            v-model="filtros.id_unidade_operacao" />
                    </div>
                    <div class="col col-12 col-md-3">
                        <az-input
                            icon="fas fa-user-md fa-fw"
                            type="select"
                            placeholder="Todos os Médicos..."
                            optionsMode="aql"
                            service="medicos.index"
                            optionsName="medicos-cadastro"
                            :optionsParm="{ ativos: true }"
                            optionsData="id_pessoa"
                            v-model="filtros.id_medico" />
                    </div>
                </div>
                <div class="form-row mt-2">
                    <div class="col col-12 col-md-2">
                        <az-input
                            icon="fa fa-play fa-fw"
                            placeholder="Todos..."
                            type="select"
                            optionsMode="json"
                            :optionsList="[
                                { id: 'S', search: 'Solicitados' },
                                { id: 'N', search: 'Não Solicitados' },
                            ]"
                            optionsData="id"
                            v-model="filtros.filtro_atend">
                        </az-input>                   
                    </div>

                    <div class="col col-12 col-md-10">
                        <az-input
                            icon="fa-solid fa-user fa-fw"
                            placeholder="Selecionar paciente..."
                            type="autocomplete"
                            optionsMode="aql"
                            service="pacientes.index"
                            optionsDisplay="search"
                            ref="info_paciente"
                            v-model="filtros.paciente"
                            :optimized_ac="true">
                            <template v-slot:buttonposb>
                                <div class="input-group-append" v-if="exibicao && exibicao.length" title="Quantidade">
                                    <span class="input-group-text">{{ exibicao.length }}</span>
                                </div>

                                <div class="input-group-append" v-if="filtros.paciente">
                                    <button type="button" class="btn btn-outline-primary" v-if="filtros.paciente.id_pessoa > 0" 
                                        @click="$root.perfil(filtros.paciente)" title="Paciente">
                                        <i class="fa-solid fa-id-badge"></i>
                                    </button>

                                    <button type="button" class="btn btn-outline-secondary" v-if="filtros.paciente.id_pessoa < 0" 
                                        @click="$root.perfil_temp(filtros.paciente)" title="Paciente">
                                        <i class="fa-solid fa-id-badge"></i>
                                    </button>
                                </div>
                            </template>
                        </az-input>
                    </div>
                </div>
            </div>
        </div>

        <div class="progress mt-1 mb-3">
            <div class="indeterminate" v-if="$store.state.loading && dados"></div>
            <div class="determinate" v-else></div>
        </div>

        <az-empty-state 
            :icon="ja_buscou ? '' : 'fa-solid fa-magnifying-glass'"
            :msg="ja_buscou ? '' : 'Buscar'"
            action="Buscar"
            :method="load"
            v-if="!exibicao || !exibicao.length" />

        <div v-else>
            <table class="table table-hover table-sm table-responsive-md bg-white w3-animate-opacity cabecalho-fixo">
                <thead>
                    <tr>
                        <th></th>
                        <th>Id</th>
                        <table-th title="Guia" v-model="ordem" sortby="guia_formatada"></table-th>
                        <table-th title="Data" v-model="ordem" sortby="dt_criacao"></table-th>
                        <table-th title="Início" v-model="ordem" sortby="dt_inicio_fat"></table-th>
                        <table-th title="Fim" v-model="ordem" sortby="dt_fim_fat"></table-th>
                        <table-th title="Status" v-model="ordem" sortby="prorrog_autorizacao.status_solicitacao.msg"></table-th>
                        <table-th title="Paciente" v-model="ordem" sortby="atendimento.paciente.st_nome"></table-th>
                        <table-th title="Operadora" v-model="ordem" sortby="plano.operadora.st_operadora"></table-th>
                        <th class="text-right">Valor</th>
                        <td>
                            <a href="#" @click.prevent="onSelectAll()" class="ml-1">
                                <i class="fa-solid fa-square"></i>
                            </a>
                        </td>
                    </tr>
                </thead>
                <tbody>
                    <template v-for="(guia, index) in exibicao">
                        <tr :key="index" :class="guia.selected ? 'table-secondary' : ''" class="table-light" v-if="true">
                            <td>
                                <span class="badge" :class="'badge-' + guia.status_color"
                                    data-toggle="tooltip" data-placement="top" :title="guia.status_guia">
                                    {{ guia.ch_status }}
                                </span>
                            </td>
                            <td>
                                <small>
                                    <a href="#" @click.prevent="abrir_atendimento(guia)" class="card-link">
                                        #{{ guia.id_atendimento }}
                                    </a>
                                    <a href="#" @click.prevent v-if="guia.atendimento.marcacao.arquivos.length">
                                        <i class="fa-solid fa-paperclip ml-1" title="Arquivos."></i>
                                    </a>
                                </small>
                            </td>
                            <td>
                                <small>
                                    <a href="#" @click.prevent="editar (guia)">
                                        {{ guia.guia_formatada }}
                                    </a>
                                </small>
                            </td>
                            <td>
                                <span class="small">
                                    {{ $util.getFormatDate (guia.dt_criacao, 'DD/MM/YYYY') }}
                                </span>
                            </td>
                            <td>
                                <span class="small" v-if="guia.dt_inicio_fat">
                                    {{ $util.getFormatDate (guia.dt_inicio_fat, 'DD/MM/YYYY') }}
                                </span>
                            </td>
                            <td>
                                <span class="small" v-if="guia.dt_fim_fat">
                                    {{ $util.getFormatDate (guia.dt_fim_fat, 'DD/MM/YYYY') }}
                                </span>
                            </td>
                            <td>
                                <a href="#" @click.prevent="ver_autorizacao(guia)" v-if="guia.prorrog_autorizacao && guia.prorrog_autorizacao.status_solicitacao">
                                    <span class="badge" :class="'badge-' + guia.prorrog_autorizacao.status_solicitacao.color">
                                        {{ guia.prorrog_autorizacao.status_solicitacao.msg }}
                                    </span>
                                </a>

                                <span class="small" v-else>
                                    Não Solicitado
                                </span>
                            </td>
                            <td class2="text-nowrap text-truncate">
                                <small>
                                    <a href="#" @click.prevent="filtrar_paciente(guia.atendimento.paciente)" class="card-link">
                                        {{ guia.atendimento.paciente.st_nome }}
                                    </a>
                                    
                                    <span class="text-success ml-1" 
                                        data-toggle="tooltip" data-placement="top" title="Pendência Resolvida"
                                        v-if="guia.ch_status == 'DI' && guia.guia_pendencias && guia.guia_pendencias.length == 1 
                                            && !guia.guia_pendencias[0].fl_ativo">
                                        <i class="fas fa-check-circle"></i>
                                    </span>
                                </small>
                            </td>
                            <td class2="text-nowrap text-truncate" v-if="false">
                                <small>
                                    <span v-if="guia.id_medico_faturar">
                                        {{ guia.medico_faturar.st_nome_exibicao }}*
                                    </span>
                                    <span v-else>
                                        {{ guia.atendimento.medico.st_nome_exibicao }}
                                    </span>
                                    <span class="badge badge-secondary" v-if="$store.state.unidade.unidade_operacaos.length > 1 && guia.atendimento.unidade_operacao && guia.atendimento.unidade_operacao.st_sigla">
                                        {{ guia.atendimento.unidade_operacao.st_sigla }}
                                    </span>
                                </small>
                            </td>
                            <td class2="text-nowrap text-truncate">
                                <small>
                                    {{ guia.plano.operadora.st_operadora }}
                                    <small class="text-muted" v-if="guia.plano.operadora.st_operadora != guia.plano.search">
                                        {{ guia.plano.search.slice(guia.plano.operadora.st_operadora.length + 3) }}
                                    </small>
                                    <span class="badge badge-secondary ml-1" v-if="guia.id_contrato_operadora"
                                        data-toggle2="tooltip" data-placement2="top" 
                                        :title="'Contrato: ' + 
                                            ( guia.contrato_operadora && guia.contrato_operadora.st_numero_prestador ? guia.contrato_operadora.st_numero_prestador : 'CNPJ' ) + 
                                            ' - ' + 
                                            ( guia.contrato_operadora && guia.contrato_operadora.st_descricao_arquivo_contrato ? guia.contrato_operadora.st_descricao_arquivo_contrato : '' )">
                                        #{{ guia.id_contrato_operadora }}
                                    </span>
                                </small>
                            </td>
                            <td class="text-right">
                                {{ $util.formatMoeda(guia.valor_total.total) }}
                            </td>

                            <td>
                                <div class="form-check ml-1">
                                    <input class="form-check-input" type="checkbox" v-model="guia.selected" id="defaultCheck1">
                                </div>
                            </td>
                        </tr>
                    </template>
                </tbody>
            </table>

            <!-- Menu debaixo -->
             <br><br><br>

            <!-- Paginação -->
            <nav class="navbar fixed-bottom navbar-light bg-light pb-3" v-if="dados && ( dados.last_page > 1 || ( !dados.last_page && dados.to >= dados.per_page ) ) && !selected">
                <div class="d-flex">
                    <paginate
                        class="mb-0"
                        :page-count="dados.last_page ? dados.last_page : ( dados.current_page + 1 )"
                        :container-class="'pagination'"
                        :page-class="'page-item'"
                        :page-link-class="'page-link'"
                        :prev-class="'page-link'"
                        :next-class="'page-link'"
                        :prev-text="'<<'"
                        :next-text="'>>'"
                        :click-handler="paginar">
                    </paginate>
                </div>
            </nav>

            <nav class="navbar fixed-bottom navbar-light bg-light" v-if="selected">
                <a class="navbar-brand" href="#">
                    <span v-if="isNaN(progresso)">Opções</span>
                    <div style="width: 150px;" v-else>
                        <ProgressBar :value="progresso" :showValue="true">
                            {{ progresso }}%
                        </ProgressBar>
                    </div>
                </a>

                <div class='mr-3'> 
                    <button class="btn btn-sm ml-1" type="button" 
                        :class="desabilitar('prorrogar') ? 'btn-outline-secondary' : 'btn-success'"
                        :disabled="desabilitar('prorrogar')"
                        data-toggle="tooltip" data-placement="top" title="Solicitar Prorrogação"
                        @click="solicitar_prorrogacao ()">
                        <i class="fa-solid fa-stamp"></i>
                    </button>
                    <button class="btn btn-sm ml-1" type="button" 
                        :class="desabilitar('cancelar') ? 'btn-outline-secondary' : 'btn-danger'"
                        :disabled="desabilitar('cancelar')"
                        data-toggle="tooltip" data-placement="top" title="Cancelamento Solicitação"
                        @click="cancelar_prorrogacao ()">
                        <i class="fa fa-times" aria-hidden="true"></i>
                    </button>
                </div>
            </nav>
        </div>

        <ver-autorizacao ref="ver_autorizacao" />
        <guia-edicao ref="edicao" @refresh="load (false)" /> <!-- :pode_ver_conta="false" @conta="ver_conta" -->
    </div>
</template>

<script>
import $ from 'jquery';
import _ from 'lodash';
import * as moment from 'moment';
import AzPeriodo from '../../shared/forms/AzPeriodo.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import TableTh from '../../shared/table/TableTh.vue';
import VerAutorizacao from './VerAutorizacao.vue';
import GuiaEdicao from '../faturamento/GuiaEdicao.vue';

export default {
    data() {
        return {
            filtros: {
                periodo: 's', 
                tipo_data: 'F',
                paciente: null,
                id_operadora: "", 
                id_unidade_operacao: "", 
                id_medico: "", 
                filtro_atend: "", 
                pesquisar: "", 
            },
            ja_buscou: false,
            dados: null,
            ordem: "", 
            selectAll: false, 
            page: 1, 
            progresso: null, 
            pesquisar: "", 
        };
    },
    components: {
        AzPeriodo, 
        AzInput,
        AzEmptyState,
        TableTh,
        VerAutorizacao,
        GuiaEdicao, 
    },

    computed: { 
        selected: function () { 
            if ( !this.exibicao ) { 
                return false; 
            }

            return this.exibicao.findIndex(item => { 
                    return item.selected;
                }) >= 0 ;
        },

        selecteds: function () { 
            return this.exibicao.filter (item => { 
                return item.selected;
            });
        },

        valor_total: function () {
            let init = { total: 0, glosado: 0, recebido: 0, a_receber: 0, consumo: 0, a_mais: 0 };

            return this.exibicao.reduce((a, b) => { 
                return { 
                    total: a.total + parseFloat(b.valor_total.total),
                    glosado: a.glosado + parseFloat(b.valor_total.glosado),
                    recebido: a.recebido + parseFloat(b.valor_total.recebido),
                    a_receber: a.a_receber + parseFloat(b.valor_total.a_receber),
                    a_mais: a.a_mais + parseFloat(b.valor_total.a_mais), 
                    consumo: a.consumo + parseFloat(b.valor_total.consumo),
                }
            }, init);
        },
        
        valor_selecionado: function () { 
            let init = { total: 0, glosado: 0, recebido: 0, a_receber: 0, consumo: 0, a_mais: 0 };

            return this.selecteds.reduce((a, b) => { 
                return { 
                    total: a.total + parseFloat(b.valor_total.total),
                    glosado: a.glosado + parseFloat(b.valor_total.glosado),
                    recebido: a.recebido + parseFloat(b.valor_total.recebido),
                    a_receber: a.a_receber + parseFloat(b.valor_total.a_receber),
                    a_mais: a.a_mais + parseFloat(b.valor_total.a_mais), 
                    consumo: a.consumo + parseFloat(b.valor_total.consumo),
                }
            }, init);
        },

        lista_unidades: function () {
            // this.$store.state.unidade.unidade_operacaos
            return _.orderBy(
                this.$util.unidades_com_tags(true, true).filter(item => !item.fl_unidade_adm),
                'st_nome'
            );
        },

        exibicao: function () {
            if ( !this.dados )
                return [];

            //let pesquisar = this.filtros.pesquisar.trim();
            //let parts = pesquisar.replace(" ", ".*");
            //let match = parts;
            //let reg = new RegExp(match, "i");

            let reg = this.$util.getregex(this.filtros.pesquisar);
            let items;

            if (this.filtros.pesquisar) {
                items = this.dados.data.filter(item => {
                    return reg.test(JSON.stringify(item));
                });
            } else {
                items = this.dados.data;
            }

            return items;
        },
    },

    methods: {
        editar (guia) { 
            this.$refs.edicao.abrir(guia);
        },

        ver_conta (id_internacao) { 
            $('.modal').modal('hide');
            this.$refs.conta.abrir(id_internacao);
        }, 

        ver_autorizacao (guia) { 
            if ( guia.prorrog_autorizacao ) { 
                this.$refs.ver_autorizacao.abrir(guia.prorrog_autorizacao);
            }
        },

        desabilitar (botao) { 
            if ( this.$store.state.loading )
                return true;

            if ( !this.selected ) { 
                return false; 
            }

            if ( botao == 'prorrogar' ) { 
                return this.exibicao.find(item => { 
                    return item.selected && item.prorrog_autorizacao;
                });
            } else if ( botao == 'cancelar' ) { 
                return this.exibicao.find(item => { 
                    return item.selected && ( !item.prorrog_autorizacao || item.prorrog_autorizacao.in_status_geral );
                });
            }

            return false; 
        },

        ordenar (campo) { 
            this.ordem = campo;
        },

        onSelectAll (force = false) { 
            if ( this.pesquisar.substr(0,1).toUpperCase() == 'G' && !isNaN(this.pesquisar.substr(1)) ) { 
                
                let guia = this.exibicao.find(guia => guia.id_guia == this.pesquisar.substr(1));

                if ( guia ) { 

                    let info = "\n" + guia.atendimento.paciente.st_nome + "\n" + guia.guia_formatada;

                    if ( guia.selected ) { 
                        this.$toast.add({ 
                            severity: "info",
                            summary: "Atenção",
                            detail: "Guia já selecionada: " + this.pesquisar + info,
                            life: 5000         
                        });    
                    } else { 
                        guia.selected = true;

                        this.$toast.add({ 
                            severity: "success",
                            summary: "Atenção",
                            detail: "Guia selecionada: " + this.pesquisar + info,
                            life: 2500         
                        });    
                    }
                } else { 
                    this.$toast.add({ 
                        severity: "error",
                        summary: "Atenção",
                        detail: "Guia não identificada: " + this.pesquisar,
                        life: 5000         
                    });
                }

                this.$nextTick(() => { 
                    this.pesquisar = "";
                });

                return;

            } else if ( this.pesquisar.substr(0,1).toUpperCase() == 'A' && !isNaN(this.pesquisar.substr(1)) ) { 
                
                let guias = this.exibicao.filter(guia => guia.id_atendimento == this.pesquisar.substr(1));

                if ( guias && guias.length ) { 

                    guias.forEach(guia => { 

                        let info = "\n" + guia.atendimento.paciente.st_nome + "\n" + guia.guia_formatada;

                        if ( guia.selected ) { 
                            this.$toast.add({ 
                                severity: "info",
                                summary: "Atenção",
                                detail: "Guia já selecionada: " + this.pesquisar + info,
                                life: 5000         
                            });    
                        } else { 
                            guia.selected = true;

                            this.$toast.add({ 
                                severity: "success",
                                summary: "Atenção",
                                detail: "Guia selecionada: " + this.pesquisar + info,
                                life: 2500         
                            });    
                        }

                    });

                } else { 

                    this.$toast.add({ 
                        severity: "error",
                        summary: "Atenção",
                        detail: "Guia não identificada: " + this.pesquisar,
                        life: 5000         
                    });

                }

                this.$nextTick(() => { 
                    this.pesquisar = "";
                });

                return;

            } else if ( this.pesquisar.substr(0,1).toUpperCase() == 'S' && !isNaN(this.pesquisar.substr(1)) ) { 

                this.load(false);
                return;

            }

            let selectAll = this.exibicao.find(item => !item.selected);

            let selected = force ? force : selectAll;
            _.forEach(this.exibicao, element => {
                element.selected = selected;
            });

            this.$nextTick(() => {
                this.$forceUpdate ();
            });
        },

        paginar (page) {
            this.page = page;
            this.load(false);
        },

        copiar_texto(texto, msg = null) { 
            this.$util.copiar_clipboard(this, texto, msg);
        },

        load(pagina = null) {
            if ( this.montando )
                return;

            if ( this.canceltoken ) {
                this.canceltoken.cancel('#BC#');
            }

            if ( pagina ) { 
                this.page = pagina;
            }

            this.$util.setCookie('sol-aut-fila', this.filtros.id_fila_autorizacao);

            this.canceltoken = this.axios.CancelToken.source();

            this.ja_buscou = true;

            this.$util.load(this, {
                service: "guias",
                func: "index",
                canceltoken: this.canceltoken.token,
                parms: {
                    ...this.filtros,
                    paralista: true, 
                    page: this.page,
                    size: 100,
                    prorrogacao: true, 
                },
                reload_page: true, 
                loadTo: res => {
                    this.dados = res;
                }
            });
        }, 

        solicitar_prorrogacao () { 
            if ( !confirm("Confirmar SOLICITAR de prorrogação das guias selecionadas?") )
                return;

            let ids = this.selecteds.map(item => item.id_guia);
            
            this.$util.atualizar(this, { 
                service: 'solicitacao_autorizacoes',
                func: 'prorrogacao', 
                dados: { 
                    id_guias: ids,
                },
                toast: true, 
                callback: () => { 
                    this.load();
                }
            });
        },

        cancelar_prorrogacao () { 
            if ( !confirm("Confirmar CANCELAR a solicitação de prorrogação das guias selecionadas?") )
                return;

            let ids = this.selecteds.map(item => item.id_guia);
            
            this.$util.atualizar(this, { 
                service: 'solicitacao_autorizacoes',
                func: 'cancelar_prorrogacao', 
                dados: { 
                    id_guias: ids,
                },
                toast: true, 
                callback: () => { 
                    this.load();
                }
            });
        }
    },

    beforeMount () {
        this.filtros.from = moment().subtract(30, "days").format('YYYY-MM-DD');
        this.filtros.to = moment().format('YYYY-MM-DD');

        if ( this.$route.params && this.$route.params.id ) {
            this.filtros.pesquisar = '#' + this.$route.params.id;
        }
    },

    mounted() {
        this.$store.commit("setBreadcrumb", [
            { name: "Autorizações", path: "/autorizacoes/lista" },
            { name: "Prorrogação", path: "/autorizacoes/prorrogacao" },
        ]);

        this.$nextTick(() => {
            this.montando = false;
            
            if ( this.filtros.pesquisar ) { 
                this.load();
            }
        });        
    },

    updated() {
        $('[data-toggle="tooltip"]').tooltip();
    },
};
</script>

<style scoped>
.modal-dialog-total {
  top: 0;
  width: 100% !important;
  height: 100% !important;
  padding: 0 !important;
  max-width: 100% !important;
  max-height: 100% !important;
  margin-top: 0px;
  margin-bottom: 0px;
  margin: 0px !important;
}

.modal-content-total {
  height: 100% !important;
  max-height: 100% !important;
}

.modal-dialog2 {
  width: 98% !important;
  padding: 0 !important;
  max-width: 100%;
}
</style>